import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

const MapContext = createContext(null);

export function MapProvider({ children }) {
  const [satelliteMap, setSatelliteMap] = useState(false);
  const [satelliteLayers, setSatelliteLayers] = useState([]);
  const [satelliteHovered, setSatelliteHovered] = useState(false);
  const [virtualDeviceCoord, setVirtualDeviceCoord] = useState('');
  const [isOpenRegModal, setIsOpenRegModal] = useState(false);
  const [isLegendCollapsed, setIsLegendCollapsed] = useState(false);

  const toggleSatelliteLayer = useCallback(layerType => {
    setSatelliteLayers(prev => (prev.includes(layerType) ? [] : [layerType]));
  }, []);

  const isLayerActive = useCallback(layerType => satelliteLayers.includes(layerType), [satelliteLayers]);

  const value = useMemo(
    () => ({
      satelliteMap,
      setSatelliteMap,
      satelliteLayers,
      setSatelliteLayers,
      satelliteHovered,
      setSatelliteHovered,
      virtualDeviceCoord,
      setVirtualDeviceCoord,
      isOpenRegModal,
      setIsOpenRegModal,
      toggleSatelliteLayer,
      isLayerActive,
      isLegendCollapsed,
      setIsLegendCollapsed,
    }),
    [
      satelliteMap,
      satelliteLayers,
      satelliteHovered,
      virtualDeviceCoord,
      isOpenRegModal,
      toggleSatelliteLayer,
      isLayerActive,
      isLegendCollapsed,
    ]
  );

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
}

export function useMapContext() {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error('useMapContext deve ser usado dentro de MapProvider');
  }
  return context;
}
